import { inject, Injectable } from '@angular/core';
import { ICreatorCtaKpiStatusApi, ICtaKpiStatusApi } from '@interfaces/campaign-analytics-api.interface';
import { ICampaignDetailsOverviewData } from '../campaign-details.interface';
import { CampaignDetailsService } from '../campaign-details.service';

@Injectable({
  providedIn: 'root',
})
export class CampaignDetailsOverviewService {
  private readonly campaignDetailsService = inject(CampaignDetailsService);

  public buildOverviewData(
    creatorsCtaKpiStatus: ICreatorCtaKpiStatusApi[] | null | undefined,
  ): ICampaignDetailsOverviewData | null {
    if (!creatorsCtaKpiStatus) {
      return null;
    }

    return {
      ctaKpiStatus: this.aggregateCreatorCtaKpiStatuses(creatorsCtaKpiStatus),
    };
  }

  private aggregateCreatorCtaKpiStatuses(creators: ICreatorCtaKpiStatusApi[]): ICtaKpiStatusApi {
    return creators.reduce<ICtaKpiStatusApi>((aggregatedStatus, creator) => {
      const s = creator.ctaKpiStatus;

      // Deliverables
      aggregatedStatus.totalDeliverables += s.totalDeliverables;
      aggregatedStatus.expectedDeliverables += s.expectedDeliverables;
      aggregatedStatus.currentProcessingDeliverables += s.currentProcessingDeliverables;
      aggregatedStatus.currentFailedDeliverables += s.currentFailedDeliverables;
      aggregatedStatus.currentProblemDeliverables += s.currentProblemDeliverables;
      aggregatedStatus.currentOkDeliverables += s.currentOkDeliverables;
      aggregatedStatus.currentBonusDeliverables += s.currentBonusDeliverables;

      // KPIs
      aggregatedStatus.expectedKpis += s.expectedKpis;
      aggregatedStatus.currentProcessingKpis += s.currentProcessingKpis;
      aggregatedStatus.currentFailedKpis += s.currentFailedKpis;
      aggregatedStatus.currentProblemKpis += s.currentProblemKpis;
      aggregatedStatus.currentOkKpis += s.currentOkKpis;

      // Contents
      aggregatedStatus.expectedContents += s.expectedContents;
      aggregatedStatus.currentProcessingContents += s.currentProcessingContents;
      aggregatedStatus.currentFailedContents += s.currentFailedContents;
      aggregatedStatus.currentProblemContents += s.currentProblemContents;
      aggregatedStatus.currentOkContents += s.currentOkContents;
      aggregatedStatus.currentUnrelatedContents += s.currentUnrelatedContents;
      aggregatedStatus.currentBonusContents += s.currentBonusContents;
      aggregatedStatus.currentMatchedContents += s.currentMatchedContents;
      aggregatedStatus.currentMissingContents += s.currentMissingContents;

      return aggregatedStatus;
    }, this.campaignDetailsService.createEmptyCtaKpiStatusApi());
  }
}
